module.exports = __webpack_public_path__ + "img/logo.99179467.svg";